import {
    ToolCompleted, ToolStarted, ToolSummaryDelta
} from '@common/api/agentService';
import Icon from '@common/components/Icon';
import Tooltip from '@common/components/Tooltip';
import React from 'react';
import styles from './Tool.module.scss';
import { TOOL_MAP } from './toolConfig';

const Started: React.FC<{message: ToolStarted}> = ({ message }) => {
    const toolName = message?.tool_name as string;
    const args = message?.input_args || {};
    const toolSummary = message.tool_summary;
    const cfg = TOOL_MAP[toolName] || {
        title: toolName,
        describe: (args) => JSON.stringify(args || {}),
        icon: 'search',
    };

    return (
        <Tooltip content={cfg?.describe(args) || cfg?.title + ' - ' + toolSummary}>
            <div className={styles.toolStartCard}>
                <div className={styles.toolStartLeft}>
                    <div className={styles.toolStartIcon}>
                        <Icon name={cfg?.icon} size={20} />
                    </div>
                    <div className={styles.toolStartText}>
                        <span className={styles.toolStartLabel}>
                            {cfg?.title}
                            {' - '}
                        </span>
                        <span className={styles.toolStartQuery}>
                            {cfg?.describe(args) || toolSummary}
                        </span>
                    </div>
                </div>
                {/* <div className={styles.toolStartRight}>
                <div
                    className={styles.toolStartButton}
                    onClick={onViewDetails}
                >
                    View details
                </div>
            </div> */}
            </div>
        </Tooltip>

    );
}

const Completed: React.FC<{message: ToolCompleted}> = ({ message }) => {
    return (
        <div className={styles.toolCompletedCard}>
            {message.output_summary}
        </div>
    );
}

const Summary: React.FC<{message: ToolSummaryDelta}> = ({ message }) => {
    return (
        <div className={styles.toolSummary}>
            {message.content}
        </div>
    )
}

export { Completed, Started, Summary };

